var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SDialog',{attrs:{"value":_vm.value,"title":_vm.title,"btn-label":{ save: _vm.btnLabel }},on:{"input":function($event){return _vm.$emit('input', $event)},"save":function($event){return _vm.$emit('ok', $event)}}},[_vm._t("default",function(){return [_c('p',{staticClass:"text-xl"},[_vm._v(" "+_vm._s(_vm.description)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }